import Assignee from '../assignee';
import ConversationItem from '../conversation_item';
import createModel, { prop } from '../lib/create_model';
import CustomerProfile from '../customer_profile';
import NotificationType from './notification_type';

export default createModel({
  modelName: 'OfferedWarmTransferNotification',

  properties: {
    id: prop(String), // AD only field
    conversationId: prop(String),
    conversationItem: prop(ConversationItem),
    initiator: prop(Assignee),
    profile: prop(CustomerProfile),
  },

  overrideToJs(toJs) {
    return () => ({ ...toJs(), type: NotificationType.OFFERED_WARM_TRANSFER });
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
